module.exports = "\n<div [innerHtml] =\"data\">\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/ocean-upgrade/ocean-upgrade.component.html
// module id = ../../../../../src/app/room-availability/ocean-upgrade/ocean-upgrade.component.html
// module chunks = main